import { motion } from '@eversports/react-components/design-tokens/motion'
import Flex from '@eversports/react-components/primitives/Flex'
import Heading from '@eversports/react-components/primitives/Heading'
import React from 'react'

import { Localized } from '../../localization/react'
import BackButton from '../BackButton'

import AddOns from './AddOns'
import MultiAnswerPatronQuestion from './MultiAnswerPatronQuestion'
import PatronQuestion from './PatronQuestion'
import Policies from './Policies'
import RequiredInformation from './RequiredInformation'

const AdditionalInformationComponent: React.FC<React.PropsWithChildren<unknown>> = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ ease: 'easeInOut' }}
  >
    <Heading is="h3" marginBottom="wide">
      <Localized id="additional-info-title" />
    </Heading>
    <Flex flexDirection="column" verticalSpacing="wide">
      <MultiAnswerPatronQuestion />
      <AddOns />
      <RequiredInformation />
      <PatronQuestion />
      <Policies />
      <BackButton />
    </Flex>
  </motion.div>
)

export default AdditionalInformationComponent
